import styled from 'styled-components';
import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG } from '@oneaudi/unified-web-common';

export const TeaserContainer = styled.div<{
  numberOfComponents: number;
}>`
  max-width: 1920px;
  margin: 0 auto;
  background-color: ${({ theme }) => (theme.name === 'dark' ? 'black' : 'white')};
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr;

  padding-inline-start: var(--page-margin);
  padding-inline-end: var(--page-margin);
  column-gap: var(--spacing-relative-md);
  row-gap: var(--spacing-relative-lg);
  padding-bottom: var(--spacing-relative-lg);
  &:first-child {
    padding-block-start: var(--spacing-relative-xl);
  }

  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1) {
        return `
          grid-template-areas:
            "a a"
            "b c";
          grid-auto-columns: 1fr;
            `;
      }
      return '';
    }}
  }

  @media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1 || numberOfComponents === 3) {
        return `
          grid-template-areas:
            "a a"
            "b c";
          grid-auto-columns: 1fr;
            `;
      }
      if (numberOfComponents === 2) {
        return `
            grid-template-columns: 1fr 1fr;
            `;
      }
      return '';
    }}
  }

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1) {
        return `
            grid-template-areas:
            "a a"
            "b c";
          grid-auto-columns: 1fr;
            `;
      }
      if (numberOfComponents === 2) {
        return `
            grid-template-columns: 1fr 1fr;
            padding-bottom: var(--spacing-relative-xl);

            `;
      }

      if (numberOfComponents === 3) {
        return `
            grid-template-columns: 1fr 1fr 1fr;
            `;
      }
      return '';
    }}
  }
`;
